import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'
import {
  Box,
  Button,
  Typography,
} from '@mui/material';

import palette from "../../../theme/palette"
import CustomModal from '../../custom/CustomModal';
import { fNumber } from '../../../utils/formatNumber';
import InnerCard from 'src/components/ui/InnerCard';
import { gridSize } from 'src/utils/constants';

export const OrderNominationSummary = ({ orderData, openModal, handleCloseModal }) => {

  return (
    <>
      {orderData && (
        <CustomModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          modalTitle={"Order " + orderData?.order_id + " Summary"}
        >
          <>
            <Typography variant="inherit" sx={{ color: palette.grey[500] }}>{"Volume & Quantity in Litres"}</Typography>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid size={{ ...gridSize }} key='Supplier Name'>
                <InnerCard type={"Company"} value={orderData?.company_name} />
              </Grid>
              <Grid size={{ ...gridSize }} key='Supplier Name'>
                <InnerCard type={"Supplier"} value={orderData?.supplier_name} />
              </Grid>
              <Grid size={{ ...gridSize }} key='Unit Price'>
                <InnerCard type={"Unit/Price"} value={orderData?.unit_price} />
              </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid size={{ ...gridSize }} key='Unit Price'>
                <InnerCard type={"Unit/Price"} value={orderData?.unit_price} />
              </Grid>
              <Grid size={{ ...gridSize }} key='Cost'>
                <InnerCard type={"Cost"} value={fNumber(orderData?.cost)} />
              </Grid>
              <Grid size={{ ...gridSize }} key='Documents'>
                <InnerCard type={"Documents"} value={orderData?.documents} />
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'right' }}>
              <Button
                variant="outlined"
                sx={{ mt: 2, color: 'black', backgroundColor: palette.grey[200], border: palette.grey[200], }}
                onClick={handleCloseModal}
              >
                Close
              </Button>
            </Box>
          </>
        </CustomModal>
      )}
    </>
  )
}

OrderNominationSummary.propTypes = {

  /** Selected order details */
  orderData: PropTypes.object,

  /** Flag to toggling openning of modal */
  openModal: PropTypes.bool,

  /** Callback function when closing modal */
  handleCloseModal: PropTypes.func.isRequired,

}
